import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfacecheckCirc = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color}>
      <path d="M12.02 20.952a8.933 8.933 0 1 1 .032-17.866 8.933 8.933 0 0 1-.028 17.866h-.004ZM12.024 22a10 10 0 1 0-.048-20 10 10 0 0 0 .048 20Z" />
      <g clipRule="evenodd" fillRule="evenodd">
        <path d="m17.201 9-6.556 5.621L6.8 11.322l-.8.694L10.643 16 18 9.69 17.2 9Z" />
        <path d="m17.202 8.736 1.104.953-7.663 6.575-4.95-4.248 1.107-.958 3.845 3.3 6.557-5.622Zm-.001.528-6.556 5.62L6.8 11.587l-.495.429 4.337 3.722 7.05-6.048-.492-.425Z" />
      </g>
    </g>
  </svg>
);

export default SvgInterfacecheckCirc;
